import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';

export default function ProfilePage() {
  const [activeTab, setActiveTab] = useState<'profile' | 'payments' | 'settings'>('profile');
  const [editMode, setEditMode] = useState(false);

  const paymentHistory = [
    {
      id: 1,
      date: '2025-01-01',
      description: 'Monthly HOA Dues - January 2025',
      amount: 250.00,
      status: 'Paid',
      method: 'Credit Card ****4242'
    },
    {
      id: 2,
      date: '2024-12-01',
      description: 'Monthly HOA Dues - December 2024',
      amount: 250.00,
      status: 'Paid',
      method: 'Credit Card ****4242'
    },
    {
      id: 3,
      date: '2024-11-01',
      description: 'Monthly HOA Dues - November 2024',
      amount: 250.00,
      status: 'Paid',
      method: 'Credit Card ****4242'
    },
    {
      id: 4,
      date: '2024-10-01',
      description: 'Monthly HOA Dues - October 2024',
      amount: 250.00,
      status: 'Paid',
      method: 'Credit Card ****4242'
    },
    {
      id: 5,
      date: '2024-09-01',
      description: 'Monthly HOA Dues - September 2024',
      amount: 250.00,
      status: 'Paid',
      method: 'Credit Card ****4242'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 font-['Inter',sans-serif]">
      <Navbar />

      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-3">My Account</h1>
          <p className="text-lg text-gray-600">
            Manage your profile, view payment history, and update settings
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-sm p-6">
              <div className="text-center mb-6">
                <div className="w-24 h-24 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full mx-auto mb-4 flex items-center justify-center text-white text-3xl font-bold">
                  JD
                </div>
                <h3 className="font-bold text-gray-900 text-lg">John Doe</h3>
                <p className="text-sm text-gray-600">john.doe@email.com</p>
              </div>

              <nav className="space-y-2">
                <button
                  onClick={() => setActiveTab('profile')}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-colors cursor-pointer ${
                    activeTab === 'profile'
                      ? 'bg-teal-50 text-teal-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-user-line text-xl"></i>
                  Profile
                </button>
                <button
                  onClick={() => setActiveTab('payments')}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-colors cursor-pointer ${
                    activeTab === 'payments'
                      ? 'bg-teal-50 text-teal-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-file-list-line text-xl"></i>
                  Payment History
                </button>
                <button
                  onClick={() => setActiveTab('settings')}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-colors cursor-pointer ${
                    activeTab === 'settings'
                      ? 'bg-teal-50 text-teal-600'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-settings-line text-xl"></i>
                  Settings
                </button>
              </nav>

              <div className="mt-6 pt-6 border-t border-gray-200">
                <button className="w-full flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 rounded-xl font-medium transition-colors cursor-pointer">
                  <i className="ri-logout-box-line text-xl"></i>
                  Sign Out
                </button>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            {/* Profile Tab */}
            {activeTab === 'profile' && (
              <div className="bg-white rounded-2xl shadow-sm p-8">
                <div className="flex items-center justify-between mb-8">
                  <h2 className="text-2xl font-bold text-gray-900">Profile Information</h2>
                  <button
                    onClick={() => setEditMode(!editMode)}
                    className="px-4 py-2 bg-teal-500 text-white rounded-lg font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {editMode ? 'Save Changes' : 'Edit Profile'}
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      First Name
                    </label>
                    <input
                      type="text"
                      defaultValue="John"
                      disabled={!editMode}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm disabled:bg-gray-50 disabled:text-gray-600"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Last Name
                    </label>
                    <input
                      type="text"
                      defaultValue="Doe"
                      disabled={!editMode}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm disabled:bg-gray-50 disabled:text-gray-600"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email
                    </label>
                    <input
                      type="email"
                      defaultValue="john.doe@email.com"
                      disabled={!editMode}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm disabled:bg-gray-50 disabled:text-gray-600"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone
                    </label>
                    <input
                      type="tel"
                      defaultValue="(555) 123-4567"
                      disabled={!editMode}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm disabled:bg-gray-50 disabled:text-gray-600"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Address
                    </label>
                    <input
                      type="text"
                      defaultValue="123 Oak Avenue, Unit 4B"
                      disabled={!editMode}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm disabled:bg-gray-50 disabled:text-gray-600"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      City
                    </label>
                    <input
                      type="text"
                      defaultValue="San Francisco"
                      disabled={!editMode}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm disabled:bg-gray-50 disabled:text-gray-600"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      State / ZIP
                    </label>
                    <input
                      type="text"
                      defaultValue="CA 94102"
                      disabled={!editMode}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none text-sm disabled:bg-gray-50 disabled:text-gray-600"
                    />
                  </div>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">Account Status</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-green-50 rounded-xl p-4">
                      <div className="flex items-center gap-2 text-green-700 mb-1">
                        <i className="ri-check-line text-xl"></i>
                        <span className="font-medium">Dues Status</span>
                      </div>
                      <p className="text-sm text-green-600">Paid Through Jan 2025</p>
                    </div>

                    <div className="bg-blue-50 rounded-xl p-4">
                      <div className="flex items-center gap-2 text-blue-700 mb-1">
                        <i className="ri-calendar-line text-xl"></i>
                        <span className="font-medium">Member Since</span>
                      </div>
                      <p className="text-sm text-blue-600">March 2020</p>
                    </div>

                    <div className="bg-purple-50 rounded-xl p-4">
                      <div className="flex items-center gap-2 text-purple-700 mb-1">
                        <i className="ri-star-line text-xl"></i>
                        <span className="font-medium">Account Type</span>
                      </div>
                      <p className="text-sm text-purple-600">Homeowner</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Payment History Tab */}
            {activeTab === 'payments' && (
              <div className="bg-white rounded-2xl shadow-sm p-8">
                <div className="flex items-center justify-between mb-8">
                  <h2 className="text-2xl font-bold text-gray-900">Payment History</h2>
                  <button className="px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2">
                    <i className="ri-download-line"></i>
                    Download All
                  </button>
                </div>

                <div className="space-y-4">
                  {paymentHistory.map((payment) => (
                    <div
                      key={payment.id}
                      className="flex items-center justify-between p-6 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
                    >
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                          <i className="ri-check-line text-green-600 text-xl"></i>
                        </div>
                        <div>
                          <h3 className="font-semibold text-gray-900">{payment.description}</h3>
                          <p className="text-sm text-gray-600">{payment.method}</p>
                          <p className="text-xs text-gray-500 mt-1">
                            {new Date(payment.date).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-xl font-bold text-gray-900">
                          ${payment.amount.toFixed(2)}
                        </div>
                        <span className="inline-block px-3 py-1 bg-green-100 text-green-700 text-xs rounded-full mt-2">
                          {payment.status}
                        </span>
                        <button className="block mt-2 text-sm text-teal-600 hover:text-teal-700 cursor-pointer">
                          Download Receipt
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-8 pt-8 border-t border-gray-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-1">Total Paid in 2024</h3>
                      <p className="text-sm text-gray-600">12 payments</p>
                    </div>
                    <div className="text-3xl font-bold text-gray-900">$3,000.00</div>
                  </div>
                </div>
              </div>
            )}

            {/* Settings Tab */}
            {activeTab === 'settings' && (
              <div className="space-y-6">
                {/* Notifications */}
                <div className="bg-white rounded-2xl shadow-sm p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">Notification Preferences</h2>
                  
                  <div className="space-y-4">
                    <div className="flex items-center justify-between py-4 border-b border-gray-200">
                      <div>
                        <h3 className="font-semibold text-gray-900">Email Notifications</h3>
                        <p className="text-sm text-gray-600">Receive updates via email</p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" defaultChecked className="sr-only peer" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-500"></div>
                      </label>
                    </div>

                    <div className="flex items-center justify-between py-4 border-b border-gray-200">
                      <div>
                        <h3 className="font-semibold text-gray-900">Payment Reminders</h3>
                        <p className="text-sm text-gray-600">Get reminded before dues are due</p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" defaultChecked className="sr-only peer" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-500"></div>
                      </label>
                    </div>

                    <div className="flex items-center justify-between py-4 border-b border-gray-200">
                      <div>
                        <h3 className="font-semibold text-gray-900">Meeting Notifications</h3>
                        <p className="text-sm text-gray-600">Alerts for upcoming meetings</p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" defaultChecked className="sr-only peer" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-500"></div>
                      </label>
                    </div>

                    <div className="flex items-center justify-between py-4">
                      <div>
                        <h3 className="font-semibold text-gray-900">Community Updates</h3>
                        <p className="text-sm text-gray-600">News and announcements</p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" defaultChecked className="sr-only peer" />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-teal-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-500"></div>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Auto-Pay */}
                <div className="bg-white rounded-2xl shadow-sm p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">Auto-Pay Settings</h2>
                  
                  <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl p-6 mb-6">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-refresh-line text-white text-2xl"></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="font-bold text-gray-900 mb-2">Auto-Pay Enabled</h3>
                        <p className="text-sm text-gray-700 mb-3">
                          Your monthly dues of $250.00 will be automatically charged on the 1st of each month
                        </p>
                        <p className="text-sm text-gray-600">
                          Payment Method: Credit Card ending in 4242
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-4">
                    <button className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                      Update Payment Method
                    </button>
                    <button className="px-6 py-3 border-2 border-red-300 text-red-600 rounded-xl font-medium hover:bg-red-50 transition-colors whitespace-nowrap cursor-pointer">
                      Disable Auto-Pay
                    </button>
                  </div>
                </div>

                {/* Security */}
                <div className="bg-white rounded-2xl shadow-sm p-8">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">Security</h2>
                  
                  <div className="space-y-4">
                    <button className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer">
                      <div className="flex items-center gap-3">
                        <i className="ri-lock-password-line text-xl text-gray-700"></i>
                        <span className="font-medium text-gray-900">Change Password</span>
                      </div>
                      <i className="ri-arrow-right-s-line text-xl text-gray-400"></i>
                    </button>

                    <button className="w-full flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer">
                      <div className="flex items-center gap-3">
                        <i className="ri-shield-check-line text-xl text-gray-700"></i>
                        <span className="font-medium text-gray-900">Two-Factor Authentication</span>
                      </div>
                      <i className="ri-arrow-right-s-line text-xl text-gray-400"></i>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
